<div class="d-inline-block">
<table class="table table-striped table-sm my-0">
    <thead>
        <tr>
            <th role="button" class="mx-1 px-2" (click)="bExpanded=!bExpanded">
            {{title}} <i class="pl-2 fa small" [ngClass]="'fa-chevron-'+(bExpanded?'down':'right')"></i>
            </th>
        </tr>
    </thead>
    <tbody *ngIf="bTabSelected && bExpanded">
        <tr *ngIf="!scoutAndPathInitialized">
            <td><i class="fa fa-spinner fa-spin"></i></td>
        </tr>
        <ng-container *ngIf="scoutAndPath$ | async as scoutAndPath;">
        <tr>
            <td>
                <div>
                    <b>Building:</b> <a href="javascript:false;" (click)="onShowBuilding(scoutAndPath.scoutTask?.buildingId)">
                        {{scoutAndPath.scoutTask?.buildingId}}
                    </a>
                    &nbsp;<b>Scout Path:</b> <a href="javascript:false;" (click)="onShowScoutPath(scoutAndPath.scoutTask,scoutAndPath.scoutPath)">
                        #{{scoutAndPath.scoutPath?.pathNumber}}
                    </a>
                    &nbsp;&nbsp;
                    {{scoutAndPath.scoutPath?.description}}
                </div>
            </td>
        </tr>
        <tr>
            <td>
                <div class="d-flex flex-wrap">
                    <div *ngFor="let pt of scoutAndPath.scoutPath?.scoutPoints">
                        <div class="card m-1" [ngClass]="{
                        'selected-point':selectedPointId&&(selectedPointId==pt.pointId||(!pt.pointId&&selectedPointId==pt.exPointId)),
                        'scout-pt-disabled': pt.disabled
                        }">
                            <div class="p-1 pb-0 m-0">
                            <div *ngIf="pt.pointId||pt.exPointId" [ngClass]="{
                                'scout-pt-title-disabled': pt.disabled
                            }">
                                {{pt.pointId||pt.exPointId}}
                            </div>
                            <div *ngIf="pt.parentName" class="small font-italic">
                                {{pt.horizontalDistance|number:'1.0-2'}}m from <span class="font-weight-bold" [ngStyle]="{color: pt.parentColor}">{{pt.parentName}}</span> @ {{pt.bearing|number:'1.0-2'}}&deg;
                            </div>
                            <div class="small font-italic">
                                Wall Refs: <span class="font-weight-bold">#1</span> {{pt.refData.location1Distance|number:'1.0-2'}}m
                                &nbsp;<span class="font-weight-bold">#2</span> {{pt.refData.location2Distance|number:'1.0-2'}}m
                            </div>
                            </div>
                            <div class="m-1 h-100 d-flex flex-row">
                                <a href="javascript:false;"
                                (click)="onShowScoutPoint(scoutAndPath.scoutTask,scoutAndPath.scoutPath,pt)" class="scout-point-link d-flex flex-column justify-content-center"
                                [ngStyle]="{'border': 'solid 2px ' + pt.color }" title="{{pt.pointId||pt.exPointId}} {{pt.envData?.bInterior?'Interior':pt.envData?.bInterior===false?'Exterior':''}}">
                                {{pt.name}}
                                <i *ngIf="pt.envData && pt.envData.bInterior===false" class="fa fa-building text-muted mx-auto"></i>
                                </a>
                                <app-scout-point-photo-browser *ngIf="pt.type!='VIA'" class="p-sm-1 small"
                                    [scoutTask]="scoutAndPath.scoutTask"
                                    [scoutPath]="scoutAndPath.scoutPath"
                                    [scoutPoint]="pt"
                                    [locked]="true"
                                    (photoSelected)="onShowScoutPointPhoto($event)">
                                </app-scout-point-photo-browser>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
        </ng-container>
    </tbody>
</table>
<div class="alert alert-warning" *ngIf="warningMsg">
{{warningMsg}}
</div>
</div>